export function newGroupPatcher(data) {
    return {
        __typename: 'NewGroupMutation',
        ...data,
        newGroup: {
            __typename: 'NewGroup',
            ...data.newGroup,
        },
    };
}
